import React from 'react';
import PropTypes from 'prop-types';
import DeviceInfoContext from './deviceInfoContext';

class RenderByDeviceType extends React.Component {

    render() {

        const desktopView = this.props.desktop;
        const mobileView = this.props.mobile;
        const tabletView = this.props.tablet || this.props.desktop;

        return (
            <React.Fragment>
                <DeviceInfoContext.Consumer>
                    {(deviceInfo) => {

                        if (deviceInfo.device === 'mobile') {
                            return (mobileView);
                        }

                        if (deviceInfo.device === 'tablet') {
                            return (tabletView);
                        }

                        return (desktopView);
                    }}
                </DeviceInfoContext.Consumer>
            </React.Fragment>
        );
    }
}

RenderByDeviceType.propTypes = {
    desktop: PropTypes.element.isRequired,
    mobile: PropTypes.element.isRequired,
    tablet: PropTypes.element
};

export default RenderByDeviceType;